// extracted by mini-css-extract-plugin
export default {"KBSingleList":"KBSingleList_KBSingleList__LsMGG","Top":"KBSingleList_Top__ZI+7O","Name":"KBSingleList_Name__fTqHr","Description":"KBSingleList_Description__CG6gv"};